export class NewsItemPage {
    private newsHeader: HTMLElement | null;
    constructor() {
        this.newsHeader = document.querySelector('[data-news-header]');
    }
    public initialize(): void {
        // if (this.newsHeader) {
        //     if (this.newsHeader?.offsetHeight > 1000) {
        //         this.newsHeader?.classList.add('title-size-40');
        //         return;
        //     }
        //     if (this.newsHeader?.offsetHeight > 800) {
        //         this.newsHeader?.classList.add('title-size-45');
        //         return;
        //     }
        //     if (this.newsHeader?.offsetHeight > 650) {
        //         this.newsHeader?.classList.add('title-size-50');
        //         return;
        //     }
        //     if (this.newsHeader?.offsetHeight > 450) {
        //         this.newsHeader?.classList.add('title-size-55');
        //         return;
        //     }
        //     if (this.newsHeader?.offsetHeight > 350) {
        //         this.newsHeader?.classList.add('title-size-65');
        //         return;
        //     }
        // }
    }
}
